import domready from 'domready';

import experiences from './front-page/experiences';


domready(() => {
  experiences();
/**
 * Inspiration Slider 
 */
  const $tripslider = document.querySelector('.js-front-page-trips');
  const $cardAmount = Math.ceil($tripslider.scrollWidth / 370);
  const flktyTrip = Flickity.data($tripslider);
  const flktyTripData = flktyTrip.cells; 

  const changeClassName = () => {
    if (Flickity) {

      flktyTrip.on( 'select', function() {
        let target = flktyTrip.selectedCell.target;

        // The slider is at the end of the container 
        if ( target == flktyTrip.getLastCell().target ) {
          if ($cardAmount >= 1) {
            if ($cardAmount == 4) {

              flktyTripData[flktyTripData.length-3].element.className = 't-trips__article carousel-cell lazyloaded is-selected'; 
              flktyTripData[flktyTripData.length-2].element.className = 't-trips__article carousel-cell lazyloaded is-selected'; 
            } 
            else if ($cardAmount == 3) {
              flktyTripData[flktyTripData.length-2].element.className = 't-trips__article carousel-cell lazyloaded is-selected'; 
            }
          }
        } 
        // slider is less than 5 cards in a wider screen
        else if ($tripslider.scrollWidth >= 1180) {
          flktyTripData[flktyTripData.length-3].element.className = 't-trips__article carousel-cell lazyloaded is-selected'; 
        }
      });
    }
  }
  changeClassName();

/**
 * Disable Clickable Card
 */
  const DisableLink = () => {

    $(".js-front-page-trips-card").not(".is-selected").addClass("t-trips__article--is-disabled");
    $(".js-front-page-trips-card.is-selected").removeClass("t-trips__article--is-disabled");

  }
  DisableLink();

  // Watch Slider Data, run  the disablelink function when slider data is changed
  flktyTrip.on( 'change', function() {
    DisableLink();
  });

/**
 * Check if device is touchable and change the css style for touchable screen
 */
  const cardfooterStyle = {
    opacity: 1,
    transform: 'translateY(0px)'
  };
  const tabletSize = window.matchMedia("(min-width: 768px)");

  if ("ontouchstart" in document.documentElement ) {
    // console.log("your device is a touch screen device.");
    if (tabletSize.matches) {
      // console.log(`tablets width`, window.matchMedia("(min-width: 768px)"));
      $('.t-trips__article__header').css('transform', 'translateY(0px)');
      $('.t-trips__article__footer').css(cardfooterStyle);
      $('.is-hidden').css('opacity', '1');
    }
  } 

})